import * as Yup from "yup";
import {
  NameValidationNoSpace,
  PasswordRegex,
} from "../../../utils/RegexUtils";
import { getPhoneNumberJson } from "../utils/core_utils";

export const getCompanyUserValidation = (t) => {
  return Yup.object({
    userCode: Yup.string().label("First name"),
    userRoleType: Yup.string().label("User Role").required(),
    firstName: Yup.string()
      .label("First name")
      .matches(
        NameValidationNoSpace,
        t("createUserForm.firstName.matchesRegex")
      )
      .max(40, t("createUserForm.firstName.max40"))
      .required(t("createUserForm.firstName.required")),
    lastName: Yup.string()
      .label("Last name")
      .matches(NameValidationNoSpace, t("createUserForm.lastName.matchesRegex"))
      .max(40, t("createUserForm.lastName.max40"))
      .required(t("createUserForm.lastName.required")),
    emailId: Yup.string()
      .email(t("createUserForm.emailId.matchesRegex"))
      .label("Email")
      .when("userRoleType", {
        is: (userRoleType = "") => userRoleType !== "RU",
        then: Yup.string().required(t("createUserForm.emailId.required")),
      }),
    mobileNumber: Yup.string()
      .label("Mobile number")
      .when("userRoleType", {
        is: (userRoleType = "") => userRoleType !== "RU",
        then: Yup.string()
          .test(
            "mobile-number",
            t("createUserForm.mobileNo.matchesRegex"),
            (val) => {
              return getPhoneNumberJson(val).valid;
            }
          )
          .required(t("createUserForm.mobileNo.required")),
      }),
    password: Yup.string()
      .label("Password")
      .matches(PasswordRegex, t("createUserForm.password.matchesRegex")),
    confirmPassword: Yup.string()
      .label("Confirm password")
      .oneOf(
        [Yup.ref("password"), null],
        t("createUserForm.confirmPass.passwordNotMatch")
      )
      .matches(PasswordRegex, t("createUserForm.confirmPass.matchesRegex"))
      .when("password", {
        is: (password = "") => password.length > 0,
        then: Yup.string().required(
          t("createUserForm.confirmPass.matchWithPass")
        ),
      }),
    isActive: Yup.boolean(),
  });
};
